(function () {
    'use strict';

    angular.module('NaviaqWebApp').controller('AdministrationController', administrationController);

    administrationController.$inject = ['$scope', '$state', 'authService', 'administrationSections'];

    function administrationController($scope, $state, authService, administrationSections) {
        $scope.tabsVisibility = {
            logActions: true,
            vessels: true,
            roleAdministration: true,
            dayCounterAdministration: authService.hasPermission('UserAdministrationView'),
            customers: true,
            units: true,
            persons: true,
            landbases: true,
            documentTypes: true,
            lists: true,
            orderProcess: true,
            logActionPairs : true,
            jobTitle : true,
            contractor: $scope.authData.isSuperuser,
            tags : authService.hasPermission('TagAdmin'),
            locationSharing: true
        };
        $scope.visibleTabIndex = 0;
        $scope.currentSection = administrationSections[0];

        initController();

        function initController() {
            updateCurrentSection();
            $scope.$on('$stateChangeSuccess', updateCurrentSection);
        }

        function updateCurrentSection() {
            var section = getSectionByState($state.current.name) || administrationSections[0];
            $scope.currentSection = section;
            $scope.visibleTabIndex = section.index;
        }

        function getSectionByState(stateName) {
            return administrationSections.filter(function (s) {
                return s.state === stateName;
            })[0];
        }
    }
})();
